/*SYSTEM IMPORTS*/
    import React, { PureComponent, Fragment } from 'react'
    import c from 'classnames'

/*INTERNAL VIEWS*/
    import RootLayout from 'containers/RootLayout'

    import Loader from 'components/Loader'

/*HELPERS*/
    import { ConnectReduxWith } from 'helpers/Redux/connectRedux'

/*CORE*/
    import AppCore from 'cores/AppCore'

@ConnectReduxWith( 'ui', 'settings' )
class App extends PureComponent {
    componentDidMount() {
        AppCore.initialize()
    }
    
    render() {
        const { children, ui = {} } = this.props

        const { not_found = false, is_loading = false } = ui

        return (
            <RootLayout className={c({ 'not-found': not_found, is_loading })}>
                {!is_loading && children }

                {is_loading && <Loader />}
            </RootLayout>
        )
    }
}

export default App
